import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { isPlatformServer } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { environment } from 'apps/pedixapp/src/environments/environment';
import { ApiV1_ProductStock } from '@pedix-workspace/api-v1';

@Injectable({
  providedIn: 'root',
})
export class EstablishmentsStockService {
  private http = inject(HttpClient);
  private platformId = inject(PLATFORM_ID);

  async get(establishmentId: string): Promise<ApiV1_ProductStock[] | null> {
    if (isPlatformServer(this.platformId)) {
      return [];
    }

    const apiUrl = `${environment.apiV1Url}/establishments/${establishmentId}/stock`;

    const response = await firstValueFrom(
      this.http.get<{ productStock: ApiV1_ProductStock[] }>(apiUrl),
    ).catch(error => {
      console.error('Error fetching product stock:', error);

      return null;
    });

    return response ? response.productStock : null;
  }
}
